import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getResidentSummariesSuccess,
  getResidentSummariesFailure,
  getResidentSummaryDetailSuccess,
  getResidentSummaryDetailFailure,
  saveSummaryAnnotationSuccess,
  saveSummaryAnnotationFailure,
} from "./actions";
import {
  GET_RESIDENT_SUMMARIES,
  GET_RESIDENT_SUMMARY_DETAIL,
  SAVE_SUMMARY_ANNOTATION,
} from "./constants";
import QueryString from "query-string";

export function* getResidentSummariesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, ...params } = payload;
  const query = QueryString.stringify(params);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/summaries?${query}`,
    );
    yield put(getResidentSummariesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getResidentSummariesFailure());
    yield put(errorAlert("Error fetching resident summaries"));
  }
}

export function* getResidentSummaryDetailSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, summaryUuid } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/summaries/${summaryUuid}`,
    );
    yield put(getResidentSummaryDetailSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getResidentSummaryDetailFailure());
    yield put(errorAlert("Error fetching summary detail"));
  }
}

export function* saveSummaryAnnotationSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, summaryUuid, sectionKey, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/summaries/${summaryUuid}/sections/${sectionKey}/annotate`,
      formData,
    );
    yield put(saveSummaryAnnotationSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Annotation saved successfully"));
  } catch (e) {
    yield put(saveSummaryAnnotationFailure());
    yield put(errorAlert("Error saving annotation"));
  }
}

export function* getResidentSummariesFlow() {
  yield takeEvery(GET_RESIDENT_SUMMARIES, getResidentSummariesSaga);
}
export function* getResidentSummaryDetailFlow() {
  yield takeEvery(GET_RESIDENT_SUMMARY_DETAIL, getResidentSummaryDetailSaga);
}
export function* saveSummaryAnnotationFlow() {
  yield takeEvery(SAVE_SUMMARY_ANNOTATION, saveSummaryAnnotationSaga);
}

export default function* ResidentSummarySaga() {
  yield all([
    getResidentSummariesFlow(),
    getResidentSummaryDetailFlow(),
    saveSummaryAnnotationFlow(),
  ]);
}
